import { render } from "./openCall.vue?vue&type=template&id=a274850c"
import script from "./openCall.vue?vue&type=script&lang=js"
export * from "./openCall.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\owner\\Desktop\\Project\\webrtc\\tsunagaru\\tsunagaru-app\\public\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__